import { render } from "./department.vue?vue&type=template&id=a1aa23ea&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"

import "./department.vue?vue&type=style&index=0&id=a1aa23ea&scoped=true&lang=css"
import "./department.vue?vue&type=style&index=1&id=a1aa23ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a1aa23ea"

export default script